
import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";

// Lazy load pages
const Home = lazy(() => import("../pages/home/page"));
const Story = lazy(() => import("../pages/story/page"));
const JournalDetail = lazy(() => import("../pages/journal-detail/page"));
const JournalPage = lazy(() => import("../pages/journal/page"));

// Page loading placeholder
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
    <div className="flex flex-col items-center gap-4">
      <div className="w-10 h-10 border-2 border-[#7A8B7F] border-t-transparent rounded-full animate-spin"></div>
      <p className="text-sm text-[#7A8B7F] tracking-wider">SETHWOOD</p>
    </div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/story",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Story />
      </Suspense>
    ),
  },
  {
    path: "/journal",
    element: (
      <Suspense fallback={<PageLoader />}>
        <JournalPage />
      </Suspense>
    ),
  },
  {
    path: "/journal/:id",
    element: (
      <Suspense fallback={<PageLoader />}>
        <JournalDetail />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
